document.addEventListener("DOMContentLoaded", function () {
    //fancybox
    const productGall = document.getElementById('product-gall');
    if (productGall !== null) {
        Fancybox.bind("#product-gall [data-fancybox]", {
            groupAll: true,
            Thumbs: false,
            Toolbar: {
                display: {
                    left: [],
                    right: ["close"],
                },
            },
        });
    }
    //fancybox
});

window.addEventListener('scroll', function() {
    const triggerElement = document.getElementById('trigger-element');
    const addToCartButton = document.querySelector('[data-btn-add-to-cart]');

    if (addToCartButton && triggerElement) {
        const triggerRect = triggerElement.getBoundingClientRect();

        if (triggerRect.top <= 0) {
            addToCartButton.classList.add('fixed-button');
        } else {
            addToCartButton.classList.remove('fixed-button');
        }
    }
});

document.addEventListener('DOMContentLoaded', () => {
	const navItems = document.querySelectorAll('.hg-nav-items');
	const allImages = document.querySelectorAll('.hg-nav-item-image');

	allImages.forEach(img => img.classList.remove('is-active'));

	navItems.forEach(item => {
		item.addEventListener('mouseenter', () => {
			const target = item.getAttribute('data-nav-target');
			allImages.forEach(img => img.classList.remove('is-active'));

			if (target) {
				const targetImage = document.querySelector(`[data-nav-image="${target}"]`);
				if (targetImage) {
					targetImage.classList.add('is-active');
				}
			}
		});
	});
});
